import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/msalConfig';

export default function Login() {
  const { instance } = useMsal();

  const signIn = () => {
    instance.loginRedirect(loginRequest).catch((e) => console.error(e));
  };

  return (
    <div className="centered">
      <div className="card">
        <h1>CV Review</h1>
        <p className="muted">Sign in with your Office 365 account to continue.</p>
        <button className="btn-primary" onClick={signIn}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
